import React from 'react';
import { connect } from 'react-redux';
import '../../../assets/styles/components/self-defined-user-id.scss';
class SelfDefinedUserId extends React.Component {
    constructor(props) {
        super(props);
    }
    render() { 
        const { language, currentTradingAccount, username,user } = this.props; 
        let selfDefinedUserId = "-";
        if(username){
            selfDefinedUserId = username;
            selfDefinedUserId = selfDefinedUserId.substring(0,1) + "*************" + selfDefinedUserId.substring(selfDefinedUserId.length-1);
        }
        return ( 
            <React.Fragment>
                <section className={'self-defined-info font-bold'}>
                    <div className={'show-item'}>
                        <div className={'item-left'}>{language.self_defined_user_id_account_no}</div>
                        <div>{currentTradingAccount.clientID ? currentTradingAccount.clientID : '-'}</div>
                    </div>
                    <div className={'show-item'}>
                        <div className={'item-left'}>{language.self_defined_user_id_account_name}</div>
                        <div>{user.external.fullname ? user.external.fullname  : '-'}</div>
                    </div>
                    <div className={'show-item'}>
                        <div className={'item-left'}>{language.self_defined_user_id_title}</div>
                        <div>{selfDefinedUserId}</div>
                    </div>
                </section>
            </React.Fragment>
        );
    }

}

export default connect(
    state => ({
      language: state.app.language,
      currentTradingAccount: state.trade.currentTradingAccount,
      user: state.auth.user,
      username: state.auth.user.username
    })
) (SelfDefinedUserId)